import { LinkApiModel } from '../../../api/pagebuilder/models/link-api.model';
import { LinkTypeEnum } from '../enums/link-type.enum';

export class LinkModel {
    label: string = '';
    url: string = '';

    type?: LinkTypeEnum;
    tooltip?: string = null;
    openInNewWindow?: boolean = null;

    email?: string = null;
    subject?: string = null;
    body?: string = null;
    mailTo?: string = null;

    constructor(apiModel?: any) {
        if (!apiModel) {
            return;
        }

        if (apiModel.hasOwnProperty('label') && apiModel.label !== null) {
            this.label = apiModel.label;
        }

        if (apiModel.hasOwnProperty('type')) {
            this.type = apiModel.type;
        }

        if (apiModel.hasOwnProperty('url') && apiModel.url !== null) {
            this.url = apiModel.url;
        }

        if (apiModel.hasOwnProperty('tooltip')) {
            this.tooltip = apiModel.tooltip;
        }
        if (apiModel.hasOwnProperty('openInNewWindow')) {
            this.openInNewWindow = apiModel.openInNewWindow;
        }
        if (apiModel.hasOwnProperty('email')) {
            this.email = apiModel.email;
        }
        if (apiModel.hasOwnProperty('subject')) {
            this.subject = apiModel.subject;
        }
        if (apiModel.hasOwnProperty('body')) {
            this.body = apiModel.body;
        }

        if (this.email) {
            this.mailTo = this.encodeMailTo();
        }
    }

    toApi(): LinkApiModel {
        const apiModel: any = {};
        apiModel.type = this.type;

        if (this.type === LinkTypeEnum.URL) {
            apiModel.tooltip = this.tooltip;
            apiModel.openInNewWindow = this.openInNewWindow;
            apiModel.url = this.url;
        }

        if (this.type === LinkTypeEnum.EMAIL) {
            apiModel.email = this.email;
            apiModel.body = this.body;
            apiModel.subject = this.subject;
        }

        return apiModel;
    }

    clone(): LinkApiModel {
        const apiModel: any = this.toApi();
        apiModel.label = this.label;

        return new LinkModel(apiModel);
    }

    encodeMailTo(): string {
        let mailTo = `mailto:${this.email}?`;
        if (this.subject) {
            const encodedSubject = encodeURI(this.subject);
            mailTo += `subject=${encodedSubject}`;
        }
        if (this.body) {
            if (this.subject) {
                mailTo += '&';
            }

            const encodedBody = encodeURI(this.body);
            mailTo += `body=${encodedBody}`;
        }

        return mailTo;
    }

    decodeUrl(link: string): LinkModel {
        if (!link) {
            return null;
        }

        const decodedLink: LinkModel = new LinkModel();
        if (link.includes('mailto:')) {
            const [emailAndMailTo, subjectAndBody] = link.split('?');
            const [, email] = emailAndMailTo.split('mailto:');

            const ampersandIndex = subjectAndBody.indexOf('&');
            const [, subject] = subjectAndBody
                .substring(
                    subjectAndBody.indexOf('subject='),
                    ampersandIndex < 0 ? subjectAndBody.length : ampersandIndex
                )
                .split('subject=');

            const [, body] = subjectAndBody.split('body=');

            decodedLink.type = LinkTypeEnum.EMAIL;
            decodedLink.email = email;
            decodedLink.subject = subject ? decodeURI(subject) : undefined;
            decodedLink.body = body ? decodeURI(body) : undefined;
        } else {
            decodedLink.type = LinkTypeEnum.URL;
            decodedLink.url = link;
        }

        return decodedLink;
    }

    equals(other?: LinkModel): boolean {
        if (!other) {
            return false;
        }

        if (this.label !== other.label) {
            return false;
        }
        if (this.type !== other.type) {
            return false;
        }
        if (this.url !== other.url) {
            return false;
        }
        if (this.tooltip !== other.tooltip) {
            return false;
        }
        if (this.openInNewWindow !== other.openInNewWindow) {
            return false;
        }
        if (this.email !== other.email) {
            return false;
        }
        if (this.subject !== other.subject) {
            return false;
        }
        if (this.body !== other.body) {
            return false;
        }

        return true;
    }
}
